import { GatewayId } from '@pillar-portal/database/dist/enums';
import {
    IpgSystemId,
    IpgSystemIdKey,
    ThirdPartySystemId,
    type SupportedIpgSystemId,
} from '../../third-party-system.enums';

export const ValorIpgSystemId = IpgSystemId.VALOR_US;
export const ValorIpgSystemIdKey = IpgSystemIdKey.VALOR_US;
export const ValorThirdPartySystemId = ThirdPartySystemId.VALOR_US;
export const ValorGatewayId = GatewayId.VALOR_US;

export function isValorIpgSystemId(
    systemId: IpgSystemId
): systemId is SupportedIpgSystemId {
    return systemId === ValorIpgSystemId;
}

export function isValorThirdPartySystemId(
    systemId: ThirdPartySystemId
): systemId is typeof ValorThirdPartySystemId {
    return systemId === ValorThirdPartySystemId;
}

